module.exports = __webpack_public_path__ + "img/yinbao_logo1.973d3560.jpg";